var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Normalizing")]),(_vm.done)?_c('p',[_vm._v(" Finished! ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }